module.exports = __webpack_public_path__ + "img/baked_alaska.848eff7e.jpg";